import { isDefined } from "@clipboard-health/util-ts";
import { Box, Stack } from "@mui/material";
import Message from "@sendbird/uikit-react/Channel/components/Message";
import { type EveryMessage } from "@sendbird/uikit-react/types/types";
import { type SendableMessageType } from "@sendbird/uikit-react/types/utils";

import { Avatar } from "../lib/Avatar/Avatar";
import { useAgentProfilePicture } from "../ShiftBlock/hooks/useGetAgentProfilePicture";

/**
 * Sendbird channels may have auto-generated messages from cbh_urgent_shifts.
 * This user only exists in Sendbird channels, so there's no need to look them up.
 */
const CBH_URGENT_SHIFTS_USER_ID = "cbh_urgent_shifts";

interface IncomingUserChatMessageProps {
  message: SendableMessageType;
  isFirstMessageInMessageChain: boolean;
  isLastMessageInMessageChain: boolean;
}

const AVATAR_SIZE = 28;

export function IncomingUserChatMessage(props: IncomingUserChatMessageProps) {
  const { message, isFirstMessageInMessageChain, isLastMessageInMessageChain } = props;
  const { sender } = message;

  const { data: profilePicture } = useAgentProfilePicture(
    { agentId: sender.userId },
    { enabled: isDefined(sender.userId) && sender.userId !== CBH_URGENT_SHIFTS_USER_ID }
  );

  return (
    <Stack direction="row" spacing={1} alignItems="flex-end">
      <Box width={AVATAR_SIZE}>
        {isLastMessageInMessageChain && (
          <Avatar
            name={sender.nickname || "User"}
            src={profilePicture?.distribution_url}
            sx={{ width: AVATAR_SIZE, height: AVATAR_SIZE, bottom: 10 }}
          />
        )}
      </Box>
      <Message
        message={message as EveryMessage}
        chainTop={!isFirstMessageInMessageChain}
        chainBottom={!isLastMessageInMessageChain}
      />
    </Stack>
  );
}
